module.exports = __webpack_public_path__ + "static/img/fail.a3ad5aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/fail.png
// module id = edVG
// module chunks = 1